import './referral.scss';

import { Outlet } from "react-router-dom";

import { FilterReferralProvider } from "./filter-referral/filter-referral.context";

export function Referral() {
  return (
    <div id="ShellReferral" className="referral">
       <FilterReferralProvider>
        <Outlet />
      </FilterReferralProvider>
    </div>
  );
}

export default Referral;
